// extracted by mini-css-extract-plugin
export default {"contentWrapper":"AddTemplate_contentWrapper__aTx+l"};